import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { useProgrammaticFocus } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const Page = ({
  children,
  className,
  loading,
  referenceLoading,
  title,
  path,
  prevPath,
  ...props
}) => {
  const pathChanged = (path !== prevPath && typeof prevPath !== 'undefined');
  const hasLoadingItems = referenceLoading.get('itemsStarted') > 0;
  const isLoading = pathChanged && hasLoadingItems && referenceLoading.get('itemsStarted') > referenceLoading.get('itemsFinished');

  const focusToBody = useProgrammaticFocus(document.body);

  useEffect(() => {
    // We want to hide the scrollTo behind the page transition.
    // The original logic was not specific enough.
    // We don't want to trigger the scrollTo before the transition animation
    // has started.

    if (!hasLoadingItems || !pathChanged) {
      return;
    }

    if (
      // To entity navigation, done loading
      (title && !isLoading) ||
      // Navigate to homepage, done loading
      (!title && !isLoading) ||
      // Navigate to e.g. 404
      (!title && isLoading)
    ) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
      });
      focusToBody();
    }
  }, [hasLoadingItems, pathChanged, title, isLoading]);

  const classes = classNames(className, 'Page');
  const contentWrapperClasses = classNames('page--inner-wrapper', {
    'has-loading-items': hasLoadingItems,
    loading: isLoading,
  });

  return (
    <div className={classes}>
      <div className={contentWrapperClasses}>
        {children}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    referenceLoading: state.getIn(['ui', 'referenceLoading']),
  };
}

export default connect(mapStateToProps)(Page);
